import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { Appointment, AppointmentWrite, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateAppointment(): UseMutationResult<
  AxiosResponse<Appointment>,
  AxiosError<ErrorMessage>,
  AppointmentWrite
> {
  const queryClient = useQueryClient();

  const updateAppointment = (payload: AppointmentWrite): Promise<AxiosResponse<Appointment>> => {
    return client.put(`appointments/${payload?.appointmentId}/`, payload);
  };

  return useMutation(updateAppointment, {
    onSuccess: () => {
      queryClient.invalidateQueries(['appointments']);
    },
  });
}
